// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"05a4639b","508":"cc370e67"}[chunkId] + ".chunk.js";
};